/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CashAllocationEnriched } from './CashAllocationEnriched';
import {
    CashAllocationEnrichedFromJSON,
    CashAllocationEnrichedFromJSONTyped,
    CashAllocationEnrichedToJSON,
} from './CashAllocationEnriched';

/**
 * 
 * @export
 * @interface CashAllocationPage
 */
export interface CashAllocationPage {
    /**
     * 
     * @type {Array<CashAllocationEnriched>}
     * @memberof CashAllocationPage
     */
    cashAllocation: Array<CashAllocationEnriched>;
    /**
     * 
     * @type {number}
     * @memberof CashAllocationPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof CashAllocationPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the CashAllocationPage interface.
 */
export function instanceOfCashAllocationPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "cashAllocation" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function CashAllocationPageFromJSON(json: any): CashAllocationPage {
    return CashAllocationPageFromJSONTyped(json, false);
}

export function CashAllocationPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashAllocationPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cashAllocation': ((json['cash_allocation'] as Array<any>).map(CashAllocationEnrichedFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function CashAllocationPageToJSON(value?: CashAllocationPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cash_allocation': ((value.cashAllocation as Array<any>).map(CashAllocationEnrichedToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

